/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Ui_Weather_Wind_Mostly_HeadInputs */

const en_ui_weather_wind_mostly_head = /** @type {(inputs: Ui_Weather_Wind_Mostly_HeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wind ${i?.range} · mostly headwind`)
};

const de_ui_weather_wind_mostly_head = /** @type {(inputs: Ui_Weather_Wind_Mostly_HeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wind ${i?.range} · meist Gegenwind`)
};

/**
* | output |
* | --- |
* | "Wind {range} · mostly headwind" |
*
* @param {Ui_Weather_Wind_Mostly_HeadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_wind_mostly_head = /** @type {((inputs: Ui_Weather_Wind_Mostly_HeadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Wind_Mostly_HeadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_wind_mostly_head(inputs)
	return de_ui_weather_wind_mostly_head(inputs)
});